import { Settings2, AlertCircle } from 'lucide-react';
import { useAuth } from '../../auth';
import { AbsenceTypeSettings } from './AbsenceTypeSettings';
import { CompanyVacationSettings } from './CompanyVacationSettings';
import { Card, CardContent } from '@/components/ui/card';

export function HRSettings() {
  const { isHR } = useAuth();

  if (!isHR) {
    return (
      <div className="border border-red-300/60 bg-red-50 dark:border-red-500/20 dark:bg-red-900/10 rounded-lg p-6 text-center">
        <AlertCircle className="w-12 h-12 text-red-500 dark:text-red-400 mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-red-800 dark:text-red-200 mb-2">
          Kein Zugriff
        </h2>
        <p className="text-red-600 dark:text-red-300">
          Diese Seite ist nur für Mitarbeiter der Personalabteilung zugänglich.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="p-5">
          <div className="flex items-center gap-3">
            <div className="rounded-md bg-emerald-50 dark:bg-emerald-900/30 p-1.5">
              <Settings2 className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-50">
                HR-Einstellungen
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Abwesenheitsarten und Betriebsferien konfigurieren
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <AbsenceTypeSettings />
      <CompanyVacationSettings />
    </div>
  );
}
